import ApiClient from './ApiClient';

class MongoEmailTemplatesAPI extends ApiClient {
  constructor() {
    super('mongo_email_templates', { accountScoped: true });
  }
}

export default new MongoEmailTemplatesAPI();
